import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";
import { CONSULT } from "@/i18n-consult";

const CTASection = ({ interest }) => {
  const { lang } = useLang();
  const c = CONSULT[lang].homeCta;
  const href = interest ? `/contatti?area=${interest}` : "/contatti";
  return (
    <section className="relative overflow-hidden bg-ink py-24 lg:py-32 hero-grain" data-testid="final-cta-section">
      <div className="pointer-events-none absolute -right-24 top-0 hidden select-none font-serif text-[16rem] font-light leading-none text-outline-light lg:block" aria-hidden="true">
        →
      </div>
      <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-accent-bright" data-testid="final-cta-overline">
            {c.overline}
          </p>
          <h2 className="mt-5 max-w-3xl font-serif text-4xl font-light leading-[1.08] tracking-tight text-paper sm:text-5xl lg:text-6xl">
            {c.title}
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg">{c.body}</p>
          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <Link
              to={href}
              data-testid="final-cta-parliamone-button"
              className="inline-flex items-center justify-center gap-3 rounded-md bg-accent px-8 py-4 text-xs font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:bg-accent-dark"
            >
              {c.primary}
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/servizi"
              data-testid="final-cta-progetto-button"
              className="inline-flex items-center justify-center gap-3 rounded-md border border-white/30 px-8 py-4 text-xs font-semibold uppercase tracking-[0.15em] text-paper transition-colors duration-300 hover:border-accent-bright hover:text-accent-bright"
            >
              {c.secondary}
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTASection;
